import {type store} from "../../../store/store";
import {ConfigurationFieldName, type Value} from "../types";

export const onUserTypeCheckboxChange =
  (
    dispatch: typeof store.dispatch,
    userType: Value,
    userGroup: Value,
    clearValidation
  ): ((event: any) => void) =>
  () => {
    dispatch(
      clearValidation({
        name: ConfigurationFieldName.typeGroupPairs,
        parameters: {
          typeId: userType.code,
          groupId: userGroup.code
        }
      })
    );
  };
